import { useEffect, useState } from "react";
import { api } from "../lib/api";
import ProductCard from "./ProductCard";

export default function SimilarProducts({ pid }) {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get(`/products/${pid}/similar`).then((r) => setItems(r.data)); }, [pid]);
  if (!items.length) return null;
  return (
    <section className="mt-16" data-testid="similar-products">
      <h2 className="text-2xl sm:text-3xl font-extrabold tracking-tight mb-6">Similar products</h2>
      <div className="flex gap-5 overflow-x-auto no-scrollbar pb-2">
        {items.map((p, i) => <div key={p.id} className="w-56 shrink-0" data-testid={`similar-item-${p.id}`}><ProductCard p={p} i={i} /></div>)}
      </div>
    </section>
  );
}
